// Port of api/fuel/app/classes/insights/game/history.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'history',
    priority: 4,
    enabled: false,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)

        // Single UNION ALL query for all log types
        var raw = Util.queryFast(
            'SELECT log_date AS date, "collection" AS type, log_context AS context, collection_id AS detail_id, 0 AS detail_num, 0 AS detail_prev, 0 AS detail_status ' +
            'FROM log_user_collection WHERE user_id = ' + user_id + ' AND game_id = ' + game_id + ' AND log_initial_sync != 1 ' +
            'UNION ALL ' +
            'SELECT log_date AS date, "status" AS type, log_context AS context, collection_id AS detail_id, 0 AS detail_num, 0 AS detail_prev, log_status AS detail_status ' +
            'FROM log_user_collection_status WHERE user_id = ' + user_id + ' AND game_id = ' + game_id + ' AND log_initial_sync != 1 ' +
            'UNION ALL ' +
            'SELECT log_date AS date, "rating" AS type, log_context AS context, 0 AS detail_id, log_rating AS detail_num, log_previous AS detail_prev, 0 AS detail_status ' +
            'FROM log_user_rating WHERE user_id = ' + user_id + ' AND game_id = ' + game_id + ' AND log_initial_sync != 1 ' +
            'UNION ALL ' +
            'SELECT log_date AS date, "play" AS type, log_context AS context, 0 AS detail_id, log_count AS detail_num, 0 AS detail_prev, 0 AS detail_status ' +
            'FROM log_user_play WHERE user_id = ' + user_id + ' AND game_id = ' + game_id + ' AND log_initial_sync != 1 ' +
            'ORDER BY date ASC'
        )

        var timeline = []

        for (var i = 0; i < raw.length; i++) {
            var row = raw[i]

            var entry = {
                date: parseInt(row.date, 10),
                type: row.type,
                context: parseInt(row.context, 10),
                detail: {}
            }

            if (row.type === 'collection') {
                entry.detail.collection_id = parseInt(row.detail_id, 10)
            } else if (row.type === 'status') {
                entry.detail.collection_id = parseInt(row.detail_id, 10)
                entry.detail.status = parseInt(row.detail_status, 10)
            } else if (row.type === 'rating') {
                entry.detail.rating = parseFloat(row.detail_num)
                entry.detail.previous = parseFloat(row.detail_prev)
            } else if (row.type === 'play') {
                entry.detail.count = parseInt(row.detail_num, 10)
            }

            timeline.push(entry)
        }

        var limit = detail ? 500 : 5

        return {
            history: timeline.slice(0, limit),
            historyTotal: timeline.length
        }

    }
})
